module.exports = __webpack_public_path__ + "static/img/charger-gray.de846f26.png";